module.exports = __webpack_public_path__ + "static/pid-ug-16-en-signinbutton-47200c3d54ea697df5a36dd7c10cd6a7.png";